import { Field } from 'devextreme/ui/pivot_grid/data_source';

export const order_1: Field = {
  dataField: 'dimensiondata_1.ord',
  dataType: 'number',
  summaryType: 'min',
  isMeasure: true,
  area: "data",
  visible: false
};

export const value_1: Field = {
  dataField: 'value_1',
  dataType: 'number',
  summaryType: 'sum',
  isMeasure: true,
  format: {
    type: 'fixedPoint',
  },
};


export const value_1_precision: Field = {
  ...value_1,
  format: {
    type: 'fixedPoint',
    precision: 3,
  },
};

export const value_1_precision_precision1: Field = {
  ...value_1,
  format: {
    type: 'fixedPoint',
    precision: 1,
  },
};

export const value_1_data: Field = {
  ...value_1,
  area: 'data',
};

export const value_1_data_precision: Field = {
  ...value_1_data,
  format: {
    type: 'fixedPoint',
    precision: 3,
  },
};

export const value_1_data_precision2: Field = {
  ...value_1_data,
  format: {
    type: 'fixedPoint',
    precision: 2,
  },
};

export const value_1_data_precision1: Field = {
  ...value_1_data,
  format: {
    type: 'fixedPoint',
    precision: 1,
  },
};

export const value_1_no_year_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return e.field('row') && e.field('row').name === 'year' ? undefined : e.value(false);
  },
};

export const value_1_no_year_half_year_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return (e.field('row') && e.field('row').name === 'year') || (e.field('row') && e.field('row').name === 'halfYear')
      ? undefined
      : e.value(false);
  },
};

export const value_1_no_year_month_summary: Field = {
  calculateSummaryValue: (e: any) => {
    return (e.field('row') && e.field('row').name === 'year') || (e.field('row') && e.field('row').name === 'month') ? undefined : e.value(false);
  },
};

export const ertek_value_1: Field = {
  ...value_1,
  caption: 'ertek',
};

export const ertek_value_1_data: Field = {
  ...value_1_data,
  caption: 'ertek',
};

export const ertek_value_1_no_year_summary: Field = {
  ...ertek_value_1,
  ...value_1_no_year_summary,
};

export const ertek_value_1_no_year_month_summary: Field = {
  ...ertek_value_1,
  ...value_1_no_year_month_summary,
};

export const ertek_value_1_data_no_year_summary: Field = {
  ...ertek_value_1_data,
  ...value_1_no_year_summary,
};

export const ertek_value_1_data_no_year_month_summary: Field = {
  ...ertek_value_1_data,
  ...value_1_no_year_month_summary,
};

export const db_value_1: Field = {
  ...value_1,
  caption: 'db',
};

export const db_value_1_data: Field = {
  ...value_1_data,
  caption: 'db',
};

export const db_value_1_data_no_year_summary: Field = {
  ...db_value_1_data,
  ...value_1_no_year_summary,
};

export const terajoule_value_1: Field = {
  ...value_1,
  caption: 'Terajoule',
};

export const terajoule_value_1_data: Field = {
  ...value_1_data,
  caption: 'Terajoule',
};

export const TJ_value_1_data_precision: Field = {
  ...value_1_data_precision,
  caption: 'TJ',
};

export const terajoule_value_1_no_year_summary: Field = {
  ...terajoule_value_1,
  ...value_1_no_year_summary,
};

export const terajoule_value_1_no_year_month_summary: Field = {
  ...terajoule_value_1,
  ...value_1_no_year_month_summary,
};

export const terajoule_value_1_data_no_year_summary: Field = {
  ...terajoule_value_1_data,
  ...value_1_no_year_summary,
};

export const terajoule_value_1_data_precision_no_year_summary: Field = {
  ...TJ_value_1_data_precision,
  ...value_1_no_year_summary,
};

export const terajoule_value_1_data_precision: Field = {
  ...TJ_value_1_data_precision,
};

export const terajoule_value_1_data_no_year_month_summary: Field = {
  ...terajoule_value_1_data,
  ...value_1_no_year_month_summary,
};

export const terajoule_brutto_value_1: Field = {
  ...value_1,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_1_precision: Field = {
  ...value_1_precision,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_1_data: Field = {
  ...value_1_data,
  caption: 'terajoule_brutto',
};

export const terajoule_brutto_value_1_no_year_summary: Field = {
  ...terajoule_brutto_value_1,
  ...value_1_no_year_summary,
};

export const terajoule_brutto_value_1_no_year_month_summary: Field = {
  ...terajoule_brutto_value_1,
  ...value_1_no_year_month_summary,
};

export const terajoule_brutto_value_1_data_no_year_summary: Field = {
  ...terajoule_brutto_value_1_data,
  ...value_1_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_1_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_1,
  ...value_1_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_1_precision_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_1_precision,
  ...value_1_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_brutto_value_1_data_no_year_half_year_summary: Field = {
  ...terajoule_brutto_value_1_data,
  ...value_1_no_year_half_year_summary,
};

export const terajoule_brutto_value_1_data_no_year_month_summary: Field = {
  ...terajoule_brutto_value_1_data,
  ...value_1_no_year_month_summary,
};

export const terajoule_netto_value_1: Field = {
  ...value_1,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_1_precision: Field = {
  ...value_1_precision,
  caption: 'terajoule_netto',
};

export const TJ_value_1_precision: Field = {
  ...value_1_data_precision,
  caption: 'TJ',
};

export const TJ_NCV_netto_value_1_precision: Field = {
  ...value_1_data_precision,
  caption: 'TJ (NCV)',
};

export const TJ_NCV_netto_value_1_precision1: Field = {
  ...value_1_data_precision1,
  caption: 'TJ (NCV)',
};

export const terajoule_netto_value_1_data: Field = {
  ...value_1_data,
  caption: 'terajoule_netto',
};

export const terajoule_netto_value_1_no_year_summary: Field = {
  ...terajoule_netto_value_1,
  ...value_1_no_year_summary,
};

export const terajoule_netto_value_1_no_year_month_summary: Field = {
  ...terajoule_netto_value_1,
  ...value_1_no_year_month_summary,
};

export const terajoule_netto_value_1_data_no_year_summary: Field = {
  ...terajoule_netto_value_1_data,
  ...value_1_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_1_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_1,
  ...value_1_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_1_precision_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_1_precision,
  ...value_1_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const terajoule_netto_value_1_data_no_year_half_year_summary: Field = {
  ...terajoule_netto_value_1_data,
  ...value_1_no_year_half_year_summary,
};

export const terajoule_netto_value_1_data_no_year_month_summary: Field = {
  ...terajoule_netto_value_1_data,
  ...value_1_no_year_month_summary,
};

export const ezer_tonna_value_1: Field = {
  ...value_1,
  caption: 'ezer_tonna',
};

export const ezer_tonna_value_1_data: Field = {
  ...value_1_data,
  caption: 'ezer_tonna',
};

export const ezer_tonna_value_1_data_precision: Field = {
  ...value_1_data_precision,
  caption: 'kt',
};

export const KTOE_value_1_data_precision: Field = {
  ...value_1_data_precision,
  caption: 'ktoe',
};

export const ezer_tonna_value_1_no_year_summary: Field = {
  ...ezer_tonna_value_1,
  ...value_1_no_year_summary,
};

export const ezer_tonna_value_1_data_precision_no_year_summary: Field = {
  ...ezer_tonna_value_1_data_precision,
  ...value_1_no_year_summary,
};

export const KTOE_value_1_data_precision_year_summary: Field = {
  ...KTOE_value_1_data_precision,
};

export const KTOE_value_1_data_precision_no_year_summary: Field = {
  ...KTOE_value_1_data_precision,
  ...value_1_no_year_summary,
};

export const ezer_tonna_value_1_no_year_month_summary: Field = {
  ...ezer_tonna_value_1,
  ...value_1_no_year_month_summary,
};

export const ezer_tonna_value_1_data_no_year_summary: Field = {
  ...ezer_tonna_value_1_data,
  ...value_1_no_year_summary,
};

export const ezer_tonna_value_1_data_no_year_month_summary: Field = {
  ...ezer_tonna_value_1_data,
  ...value_1_no_year_month_summary,
};

export const kilo_tonna_value_1: Field = {
  ...value_1,
  caption: 'kilo_tonna',
};

export const kilo_tonna_value_1_data: Field = {
  ...value_1_data,
  caption: 'kilo_tonna',
};

export const kilo_tonna_value_1_data_precision: Field = {
  ...value_1_data_precision,
  caption: 'kilo_tonna',
};

export const kilo_tonna_value_1_data_precision1: Field = {
  ...value_1_data_precision1,
  caption: 'kilo_tonna',
};

export const kilo_tonna_value_1_no_year_summary: Field = {
  ...kilo_tonna_value_1,
  ...value_1_no_year_summary,
};

export const kilo_tonna_value_1_no_year_month_summary: Field = {
  ...kilo_tonna_value_1,
  ...value_1_no_year_month_summary,
};

export const kilo_tonna_value_1_data_no_year_summary: Field = {
  ...kilo_tonna_value_1_data,
  ...value_1_no_year_summary,
};

export const kilo_tonna_value_1_data_no_year_month_summary: Field = {
  ...kilo_tonna_value_1_data,
  ...value_1_no_year_month_summary,
};

export const ezer_kobmeter_value_1: Field = {
  ...value_1,
  caption: 'ezer_kobmeter',
};

export const ezer_kobmeter_value_1_data: Field = {
  ...value_1_data,
  caption: 'ezer_kobmeter',
};

export const ezer_kobmeter_value_1_no_year_summary: Field = {
  ...ezer_kobmeter_value_1,
  ...value_1_no_year_summary,
};

export const ezer_kobmeter_value_1_no_year_month_summary: Field = {
  ...ezer_kobmeter_value_1,
  ...value_1_no_year_month_summary,
};

export const ezer_kobmeter_value_1_data_no_year_summary: Field = {
  ...ezer_kobmeter_value_1_data,
  ...value_1_no_year_summary,
};

export const ezer_kobmeter_value_1_data_no_year_month_summary: Field = {
  ...ezer_kobmeter_value_1_data,
  ...value_1_no_year_month_summary,
};

export const millio_kobmeter_value_1: Field = {
  ...value_1,
  caption: 'Mm3',
};

export const millio_kobmeter_value_1_data: Field = {
  ...value_1_data,
  caption: 'Mm3',
};

export const millio_kobmeter_value_1_data_precision: Field = {
  ...value_1_data_precision,
  caption: 'Mm3',
};

export const millio_kobmeter_value_1_no_year_summary: Field = {
  ...millio_kobmeter_value_1,
  ...value_1_no_year_summary,
};

export const millio_kobmeter_value_1_no_year_month_summary: Field = {
  ...millio_kobmeter_value_1,
  ...value_1_no_year_month_summary,
};

export const millio_kobmeter_value_1_data_no_year_summary: Field = {
  ...millio_kobmeter_value_1_data,
  ...value_1_no_year_summary,
};

export const millio_kobmeter_value_1_data_no_year_month_summary: Field = {
  ...millio_kobmeter_value_1_data,
  ...value_1_no_year_month_summary,
};

export const megawatt_value_1: Field = {
  ...value_1,
  caption: 'MW',
};

export const megawatt_value_1_data: Field = {
  ...value_1_data,
  caption: 'MW',
};

export const megawatt_value_1_max: Field = {
  ...megawatt_value_1,
  summaryType: 'max',
};

export const megawatt_value_1_data_max: Field = {
  ...megawatt_value_1_data,
  summaryType: 'max',
};

export const kilowatt_ora_value_1: Field = {
  ...value_1,
  caption: 'kWh',
};

export const kilowatt_ora_value_1_data: Field = {
  ...value_1_data,
  caption: 'kWh',
};

export const kilowatt_ora_value_1_no_year_summary: Field = {
  ...kilowatt_ora_value_1,
  ...value_1_no_year_summary,
};

export const kilowatt_ora_value_1_no_year_month_summary: Field = {
  ...kilowatt_ora_value_1,
  ...value_1_no_year_month_summary,
};

export const kilowatt_ora_value_1_data_no_year_summary: Field = {
  ...kilowatt_ora_value_1_data,
  ...value_1_no_year_summary,
};

export const kilowatt_ora_value_1_data_no_year_month_summary: Field = {
  ...kilowatt_ora_value_1_data,
  ...value_1_no_year_month_summary,
};

export const megawatt_ora_value_1: Field = {
  ...value_1,
  caption: 'MWh',
};

export const megawatt_ora_value_1_data: Field = {
  ...value_1_data,
  caption: 'MWh',
};

export const megawatt_ora_value_1_no_year_summary: Field = {
  ...megawatt_ora_value_1,
  ...value_1_no_year_summary,
};

export const megawatt_ora_value_1_no_year_month_summary: Field = {
  ...megawatt_ora_value_1,
  ...value_1_no_year_month_summary,
};

export const megawatt_ora_value_1_data_no_year_summary: Field = {
  ...megawatt_ora_value_1_data,
  ...value_1_no_year_summary,
};

export const megawatt_ora_value_1_data_no_year_month_summary: Field = {
  ...megawatt_ora_value_1_data,
  ...value_1_no_year_month_summary,
};

export const gigawatt_ora_value_1: Field = {
  ...value_1,
  caption: 'gigawatt_ora',
};

export const gigawatt_ora_value_1_data: Field = {
  ...value_1_data,
  caption: 'gigawatt_ora',
};

export const gigawatt_ora_value_1_data_precision: Field = {
  ...value_1_data_precision,
  caption: 'gigawatt_ora',
};

export const gigawatt_ora_value_1_no_year_summary: Field = {
  ...gigawatt_ora_value_1,
  ...value_1_no_year_summary,
};

export const gigawatt_ora_value_1_no_year_month_summary: Field = {
  ...gigawatt_ora_value_1,
  ...value_1_no_year_month_summary,
};

export const gigawatt_ora_value_1_data_no_year_summary: Field = {
  ...gigawatt_ora_value_1_data,
  ...value_1_no_year_summary,
};

export const gigawatt_ora_value_1_data_precision_no_year_summary: Field = {
  ...gigawatt_ora_value_1_data_precision,
  ...value_1_no_year_summary,
};

export const gigawatt_ora_value_1_data_no_year_month_summary: Field = {
  ...gigawatt_ora_value_1_data,
  ...value_1_no_year_month_summary,
};

export const forint_value_1: Field = {
  ...value_1,
  caption: 'ezer_forint',
};

export const forint_value_1_data: Field = {
  ...value_1_data,
  caption: 'ezer_forint',
};

export const forint_value_1_no_year_summary: Field = {
  ...forint_value_1,
  ...value_1_no_year_summary,
};

export const forint_value_1_no_year_month_summary: Field = {
  ...forint_value_1,
  ...value_1_no_year_month_summary,
};

export const forint_value_1_data_no_year_summary: Field = {
  ...forint_value_1_data,
  ...value_1_no_year_summary,
};

export const forint_value_1_data_no_year_month_summary: Field = {
  ...forint_value_1_data,
  ...value_1_no_year_month_summary,
};

export const petajoule_value_1: Field = {
  ...value_1,
  caption: 'Petajoule',
};

export const petajoule_value_1_data: Field = {
  ...value_1_data,
  caption: 'Petajoule',
};

export const petajoule_value_1_data_precision: Field = {
  ...value_1_data_precision,
  caption: 'Petajoule',
};

export const petajoule_value_1_data_precision2: Field = {
  ...value_1_data_precision2,
  caption: 'PJ',
};


export const petajoule_value_1_no_year_summary: Field = {
  ...petajoule_value_1,
  ...value_1_no_year_summary,
};

export const petajoule_value_1_no_year_month_summary: Field = {
  ...petajoule_value_1,
  ...value_1_no_year_month_summary,
};

export const petajoule_value_1_data_no_year_summary: Field = {
  ...petajoule_value_1_data,
  ...value_1_no_year_summary,
};

export const petajoule_value_1_data_precision_no_year_summary: Field = {
  ...petajoule_value_1_data_precision,
  ...value_1_no_year_summary,
};

export const petajoule_value_1_data_precision2_no_year_summary: Field = {
  ...petajoule_value_1_data_precision2,
  ...value_1_no_year_summary,
};

export const petajoule_value_1_data_no_year_month_summary: Field = {
  ...petajoule_value_1_data,
  ...value_1_no_year_month_summary,
};

export const szazalek_value_1: Field = {
  ...value_1,
  caption: 'szazalek',
};

export const szazaleksz_value_1_data_precision: Field = {
  ...value_1_data_precision1,
  caption: 'szazalek',
};

export const szazalek_value_1_data_precision: Field = {
  ...value_1_data_precision1,
  caption: '%',
};

export const szazalek_value_1_no_year_summary: Field = {
  ...szazalek_value_1,
  ...value_1_no_year_summary,
};

export const szazalek_value_1_no_year_month_summary: Field = {
  ...szazalek_value_1,
  ...value_1_no_year_month_summary,
};

// export const szazalek_value_1_data_no_year_summary: Field = {
//   ...szazalek_value_1_data,
//   ...value_1_no_year_summary,
// };

export const szazalek_value_1_data_precision_no_year_summary: Field = {
  ...szazalek_value_1_data_precision,
  ...value_1_no_year_summary,
};

export const szazalek_value_1_data_precision_year_summary: Field = {
  ...szazalek_value_1_data_precision,
};

export const szazalek_value_1_data_precision_no_year_month_summary: Field = {
  ...szazalek_value_1_data_precision,
  ...value_1_no_year_month_summary,
};

export const szazaleksz_value_1_data_precision_no_year_month_summary: Field = {
  ...szazaleksz_value_1_data_precision,
  ...value_1_no_year_month_summary,
};

// export const szazalek_value_1_data_no_year_month_summary: Field = {
//   ...szazalek_value_1_data,
//   ...value_1_no_year_month_summary,
// };

export const huf_kilowatt_ora_value_1: Field = {
  ...value_1,
  caption: 'huf_kilowatt_ora',
};

export const huf_kilowatt_ora_value_1_data: Field = {
  ...value_1_data,
  caption: 'huf_kilowatt_ora',
};

export const huf_kilowatt_ora_value_1_data_precision: Field = {
  ...value_1_data_precision,
  caption: 'huf_kilowatt_ora',
};

export const huf_kilowatt_ora_value_1_no_year_summary: Field = {
  ...huf_kilowatt_ora_value_1,
  ...value_1_no_year_summary,
};

export const huf_kilowatt_ora_value_1_no_year_month_summary: Field = {
  ...huf_kilowatt_ora_value_1,
  ...value_1_no_year_month_summary,
};

export const huf_kilowatt_ora_value_1_data_no_year_summary: Field = {
  ...huf_kilowatt_ora_value_1_data,
  ...value_1_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_kilowatt_ora_value_1_data_no_year_half_year_summary: Field = {
  ...huf_kilowatt_ora_value_1_data,
  ...value_1_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_kilowatt_ora_value_1_data_precision_no_year_half_year_summary: Field = {
  ...huf_kilowatt_ora_value_1_data_precision,
  ...value_1_no_year_half_year_summary,
};

export const huf_kilowatt_ora_value_1_data_no_year_month_summary: Field = {
  ...huf_kilowatt_ora_value_1_data,
  ...value_1_no_year_month_summary,
};

export const huf_kilowatt_ora_value_1_data_precision_no_year_month_summary: Field = {
  ...huf_kilowatt_ora_value_1_data_precision,
  ...value_1_no_year_month_summary,
};

export const huf_gigajoule_brutto_value_1: Field = {
  ...value_1,
  caption: 'huf_gigajoule_brutto',
};

export const huf_gigajoule_brutto_value_1_data_precision: Field = {
  ...value_1_data_precision,
  caption: 'huf_gigajoule_brutto',
};

export const huf_gigajoule_brutto_value_1_data: Field = {
  ...value_1_data,
  caption: 'huf_gigajoule_brutto',
};

export const huf_gigajoule_brutto_value_1_no_year_summary: Field = {
  ...huf_gigajoule_brutto_value_1,
  ...value_1_no_year_summary,
};

export const huf_gigajoule_brutto_value_1_no_year_month_summary: Field = {
  ...huf_gigajoule_brutto_value_1,
  ...value_1_no_year_month_summary,
};

export const huf_gigajoule_brutto_value_1_data_no_year_summary: Field = {
  ...huf_gigajoule_brutto_value_1_data,
  ...value_1_no_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_brutto_value_1_no_year_half_year_summary: Field = {
  ...huf_gigajoule_brutto_value_1,
  ...value_1_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_brutto_value_1_data_precision_no_year_half_year_summary: Field = {
  ...huf_gigajoule_brutto_value_1_data_precision,
  ...value_1_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_brutto_value_1_data_no_year_half_year_summary: Field = {
  ...huf_gigajoule_brutto_value_1_data,
  ...value_1_no_year_half_year_summary,
};

export const huf_gigajoule_brutto_value_1_data_no_year_month_summary: Field = {
  ...huf_gigajoule_brutto_value_1_data,
  ...value_1_no_year_month_summary,
};

export const huf_gigajoule_netto_value_1: Field = {
  ...value_1,
  caption: 'huf_gigajoule_netto',
};

export const huf_gigajoule_netto_value_1_data: Field = {
  ...value_1_data,
  caption: 'huf_gigajoule_netto',
};

export const huf_gigajoule_netto_value_1_data_precision: Field = {
  ...value_1_data_precision,
  caption: 'huf_gigajoule_netto',
};

export const huf_gigajoule_netto_value_1_no_year_summary: Field = {
  ...huf_gigajoule_netto_value_1,
  ...value_1_no_year_summary,
};

export const huf_gigajoule_netto_value_1_no_year_month_summary: Field = {
  ...huf_gigajoule_netto_value_1,
  ...value_1_no_year_month_summary,
};

export const huf_gigajoule_netto_value_1_data_no_year_summary: Field = {
  ...huf_gigajoule_netto_value_1_data,
  ...value_1_no_year_summary,
};

export const huf_gigajoule_netto_value_1_data_no_year_month_summary: Field = {
  ...huf_gigajoule_netto_value_1_data,
  ...value_1_no_year_month_summary,
};

export const huf_gigajoule_netto_value_1_data_precision_no_year_month_summary: Field = {
  ...huf_gigajoule_netto_value_1_data_precision,
  ...value_1_no_year_month_summary,
};

export const huf_gigajoule_brutto_value_1_data_precision_no_year_month_summary: Field = {
  ...huf_gigajoule_brutto_value_1_data_precision,
  ...value_1_no_year_month_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_brutto_value_1_data_precisionno_year_half_year_summary: Field = {
  ...huf_gigajoule_brutto_value_1_data_precision,
  ...value_1_no_year_half_year_summary,
};

export const huf_gigajoule_netto_value_1_no_year_half_year_summary: Field = {
  ...huf_gigajoule_netto_value_1,
  ...value_1_no_year_half_year_summary,
};

// TO-DO: felvenni no halfYear summary-t mindenhova
export const huf_gigajoule_netto_value_1_data_no_year_half_year_summary: Field = {
  ...huf_gigajoule_netto_value_1_data,
  ...value_1_no_year_half_year_summary,
};
